// Reference-counted body scroll lock, shared by every overlay (modals,
// dialogs, image lightbox, spotlight, app launcher).
//
// Why this exists: each overlay used to snapshot `document.body.style.overflow`
// on open and restore it on close. When overlays STACK (a confirmDialog opened
// over another modal — routine in the CRM and Quote Builder flows) the inner
// overlay snapshots `'hidden'` and "restores" to `'hidden'` on close, leaving
// the page permanently unscrollable until a full page reload. That is the
// "page sticks, can't scroll, fixed by refresh, intermittent" bug.
//
// Counting removes the race: the lock engages on the FIRST acquire and only
// releases on the LAST, regardless of how overlays interleave. `forceClear`
// gives the router a single backstop to guarantee the page is scrollable again
// after any navigation, even if an overlay was torn down without unlocking.

let lockCount = 0;
let savedOverflow = "";

/** Acquire the scroll lock. First acquire saves the prior overflow and hides. */
export function lockScroll(): void {
  if (typeof document === "undefined") return;
  if (lockCount === 0) {
    savedOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  }
  lockCount += 1;
}

/** Release one acquire. Last release restores the saved overflow. */
export function unlockScroll(): void {
  if (typeof document === "undefined") return;
  if (lockCount === 0) return; // never over-release
  lockCount -= 1;
  if (lockCount === 0) {
    document.body.style.overflow = savedOverflow;
  }
}

/** Hard reset — drop all locks and restore scrolling. Router backstop. */
export function forceClearScrollLock(): void {
  if (typeof document === "undefined") return;
  lockCount = 0;
  document.body.style.overflow = savedOverflow || "";
  savedOverflow = "";
}
